import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { hotVideos } from '@/mocks/home';

export default function HotRecommendSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-fire-line text-primary-500 text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                热门推荐
              </h2>
            </div>
            <p className="text-sm text-foreground-500">全网最受欢迎的精选内容，热度爆表</p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>

        {/* Mobile View More */}
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/dianying"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-lg border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看更多热门
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}